module.exports = __webpack_public_path__ + "img/46_16.2517fe2d.png";